import { Typography } from '@material-ui/core'
import ContentToolbarPage from 'app/components/ContentToolbarPage'
import LargeToolbar from 'app/components/LargeToolbar'
import React, { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import NetworkError from 'app/components/NetworkError'
import { useIsOnline } from 'commons/useIsOnline'
import ManageChannelsContent from 'app/main/settings/manageChannels/manageChannelsContent/ManageChannelsContent'
import { usePlace } from 'commons/usePlace'
import { Routes } from 'app/services/routeService/routeService'

const notificationTimelineURL = Routes.notificationTimeline()

const ManageChannels = ({ history }) => {
  const [isOnline] = useIsOnline()
  const place = usePlace()

  const pushPathname = useCallback(
    (input) => {
      history.push(input)
    },
    [history],
  )

  if (!isOnline) {
    return <NetworkError onRetryFetching={() => {}} />
  }

  if (!place.enabledAutomatedCall)
    pushPathname({
      pathname: notificationTimelineURL,
    })

  return (
    <ContentToolbarPage
      contentToolbar={
        <LargeToolbar
          content={
            <>
              <Typography variant="h6">
                <FormattedMessage id="navigation.settings.manageChannels.label" />
              </Typography>
            </>
          }
        />
      }
      content={<ManageChannelsContent />}
    />
  )
}

export default ManageChannels
